import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import i18n from "../i18n";

// Mini hook i18n safe (pas de TS2589)
function useI18nSafe() {
  const [lng, setLng] = useState(
    (i18n.resolvedLanguage || i18n.language || "fr").toLowerCase()
  );
  useEffect(() => {
    const onChange = (l: string) => setLng(l.toLowerCase());
    i18n.on("languageChanged", onChange);
    return () => i18n.off("languageChanged", onChange);
  }, []);
  const t = (key: string, options?: Record<string, unknown>): string =>
    options != null
      ? String((i18n.t as any)(key, options))
      : String((i18n.t as any)(key));
  return { t, lng };
}

export const GlossaireStats = () => {
  const { t } = useI18nSafe();

  // On calcule les lignes à chaque rendu (léger, évite les warnings de deps)
  const rows = [
    { nom: t("glossary:rows.eval.name"), desc: t("glossary:rows.eval.desc") },
    { nom: t("glossary:rows.efg.name"),  desc: t("glossary:rows.efg.desc") },
    { nom: t("glossary:rows.ts.name"),   desc: t("glossary:rows.ts.desc") },
    { nom: t("glossary:rows.pie.name"),  desc: t("glossary:rows.pie.desc") },
    { nom: t("glossary:rows.eff.name"),  desc: t("glossary:rows.eff.desc") },
    { nom: t("glossary:rows.fg.name"),   desc: t("glossary:rows.fg.desc") },
    { nom: t("glossary:rows.ft.name"),   desc: t("glossary:rows.ft.desc") },
    { nom: t("glossary:rows.three.name"),desc: t("glossary:rows.three.desc") },
  ];

  return (
    <section className="min-h-screen w-full p-6 mx-auto bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-gray-100">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-2 mb-6">
          <Link
            to="/seasonstats"
            className="inline-flex items-center justify-center rounded-md p-2 text-orange-600 hover:text-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-400/50 dark:text-orange-400 dark:hover:text-orange-300"
            aria-label={t("glossary:header.backAria")}
            title={t("glossary:header.backTitle")}
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <h1 className="text-2xl font-bold text-orange-600 dark:text-orange-400">
            {t("glossary:header.title")}
          </h1>
        </div>

        {/* Card */}
        <div className="rounded-2xl border bg-white border-gray-200 shadow-sm p-4 dark:bg-gray-900 dark:border-gray-800">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left">
                  <th className="p-3 border-b border-gray-200 bg-gray-50 font-semibold text-gray-800 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700">
                    {t("glossary:table.name")}
                  </th>
                  <th className="p-3 border-b border-gray-200 bg-gray-50 font-semibold text-gray-800 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700">
                    {t("glossary:table.description")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr
                    key={i}
                    className="border-b border-gray-100 hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-gray-800/60"
                  >
                    <td className="p-3 font-medium text-gray-900 dark:text-gray-100 align-top">
                      {r.nom}
                    </td>
                    <td
                      className="p-3 text-gray-700 dark:text-gray-300 align-top"
                      // on autorise les <code> dans desc
                      dangerouslySetInnerHTML={{ __html: r.desc }}
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p
            className="mt-4 text-xs text-gray-500 dark:text-gray-400"
            dangerouslySetInnerHTML={{ __html: t("glossary:tip") }}
          />
        </div>
      </div>
    </section>
  );
};
